import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar} from 'shared/components';
import EmailBody from './EmailBody';

const SenderAvatar = observer(({entry, candidate}) => {
  let sender;
  if (entry.automated) sender = {};
  else if (entry.external) sender = { avatarColour: 'bg-waterloo', avatarInitials: entry.externalUserInitials };
  else if (entry.outbound) sender = entry.user;
  else if (entry.inbound) sender = candidate;

  return <Avatar employee={sender} collageAvatar={entry.automated} size='sm' className='left'/>;
});

const ReplyMenu = ({entry, detailsState}) => {
  if (!entry.inbound || entry.external) return null;

  return (
    <div onClick={async () => detailsState.reply(entry)} className='right py1 px3 regular jumbo clickable'>
      <i className='material-symbols-solid submarine align-middle' data-toggle='dropdown'>{'reply'}</i>
    </div>
  );
};

const FromSender = observer(({entry, candidate}) => {
  let from;
  if (entry.automated) from = 'Collage HR';
  else if (entry.external) from = entry.from;
  else if (entry.inbound) from = candidate.name;
  else if (entry.outbound) from = entry.user.name;

  return (
    <div className='h5 jumbo'>
      <FormattedMessage id='recruiting.hiring_funnel.SENDER' values={{from}}/>
    </div>
  );
});

const ToReceiver = observer(({entry, candidate}) => {
  const to = entry.outbound ? candidate.name : entry.name;

  return (
    <div className='h5 jumbo'>
      <FormattedMessage id='recruiting.hiring_funnel.RECEIVER' values={{to}} />
    </div>
  );
});

const EmailEntry = observer(({entry, detailsState, candidate}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <SenderAvatar entry={entry} candidate={candidate} />
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>
                {entry.inbound && <FormattedMessage id='recruiting.hiring_funnel.Received Email' />}
                {entry.outbound && <FormattedMessage id='recruiting.hiring_funnel.Sent Email' />}
              </div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            <FromSender entry={entry} candidate={candidate} />
            <ToReceiver entry={entry} candidate={candidate} />
          </div>
          <div>
            {entry.status && <span className={`h5 jumbo right ${entry.statusColour}`}>
              <FormattedMessage id={`recruiting.hiring_funnel.email_status.${entry.status}`}/>
            </span>}
            <ReplyMenu entry={entry} detailsState={detailsState} />
          </div>
        </div>
        <div className='pt2 h3 medium word-break'>{entry.subject}</div>
        <EmailBody
          body={entry.body}
          attachments={entry.attachments}
          onViewEntireEmail={() => detailsState.openEmailModal(entry)}
        />
      </div>
    </div>
  );
});

export default EmailEntry;
